import React, { useState } from 'react';
import { StateView } from '../common/StateView';
import { useListPhotos } from './useListPhotos';
import { PhotoGallery } from './PhotoGallery';
import { BreadcrumbGroup } from '../common/breadcrumbs';
import {
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Center,
} from '@chakra-ui/react';
import { PhotoMap } from './PhotoMap';
import { PhotographyViewType } from '../../util/types';
import { useSearchParams } from 'react-router-dom';

export const Photography: React.FC = StateView(
  useListPhotos,
  ({ photoResult }) => {
    const [searchParams] = useSearchParams();
    const [tabIndex, setTabIndex] = useState<number>(
      searchParams.get('view') === PhotographyViewType.MAP ? 1 : 0,
    );

    return (
      <>
        <BreadcrumbGroup breadcrumbPaths={['home', 'photography']} />
        <Tabs
          variant="soft-rounded"
          size="lg"
          index={tabIndex}
          onChange={(index: number) => {
            setTabIndex(index);
          }}
        >
          <Center>
            <TabList>
              <Tab>Gallery</Tab>
              <Tab>Map</Tab>
            </TabList>
          </Center>
          <TabPanels>
            <TabPanel>
              <PhotoGallery photos={photoResult} />
            </TabPanel>
            <TabPanel>
              <PhotoMap photos={photoResult} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </>
    );
  },
);
